import React from "react";
import DynamicEditForm from "../../components/AdvanceDynamicEdit/DynamicEditForm";
import { getStoredData } from "../../json/fecthData";
import { canAccessField } from "../Login/authUtils";

const InventoryPanelEdit = () => {
  const inventoryData = getStoredData()?.[1] || {};

  // ✅ Use canAccessField with logging
  const filteredFields = (inventoryData.AdminInventory || []).filter((field) =>
    canAccessField(field.fields, "InventoryPanelEdit")
  );

  return (
    <div>
      <h2>Edit {inventoryData.TitleInventory} Management</h2>
      <DynamicEditForm
        fields={filteredFields}
        apiUrl={inventoryData.ApiInventory}
        successRedirect={inventoryData.RedirectAdminInventory}
        roleCompare={inventoryData.roleCompare}
      />
    </div>
  );
};

export default InventoryPanelEdit;
